import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql } from 'gatsby';
import { RichText } from "prismic-reactjs";
import styled from "@emotion/styled";

import Layout from "../components/Layout";
import ProjectCard from "../components/ProjectCard";
import colors from "../styles/colors";

const WorkHeroContainer = styled("div")`
    background: ${colors.grey200};
    display: flex;
    justify-content: center;
    align-items: flex-end;
    overflow: hidden;
    position: relative;
    margin-bottom: 3.5em;

    img {
        width: 100%;
    }
`

const WorkTitle = styled("h1") `
    margin: 0 auto;
    text-align: center;
`

const WorkCopy = styled("div") `
    padding: 0 25%;
    margin: 0 auto;
    text-align: center;
`

const Work = ({ projects, meta, homedat }) => (
    <>
        <Helmet
            title={`Work`}
            titleTemplate={`%s | Work`}
            meta={[
                {
                    name: `description`,
                    content: meta.description,
                },
                {
                    property: `og:title`,
                    content: `Work`,
                },
                {
                    property: `og:description`,
                    content: meta.description,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: meta.author,
                },
                {
                    name: `twitter:title`,
                    content: meta.title,
                },
                {
                    name: `twitter:description`,
                    content: meta.description,
                },
            ].concat(meta)}
        />
        <Layout>
            <WorkTitle>
                {RichText.render(homedat.work_title)}
            </WorkTitle>
            {/* {homedat.work_image && (
                <WorkHeroContainer>
                    <img src={homedat.work_image.url} alt={homedat.work_image.alt} />
                </WorkHeroContainer>
            )} */}
            <WorkCopy>
                {RichText.render(homedat.work_copy)}
            </WorkCopy>
            <>
                {projects.map((project, i) => (
                    <ProjectCard
                        key={i}
                        title={project.node.title}
                        subtitle={project.node.subtitle}
                        description={project.node.preview_description}
                        thumbnail={project.node.thumbnail}
                        uid={project.node._meta.uid}
                    />
                ))}
            </>
        </Layout>
    </>
);

export default ({ data }) => {
    const homedat = data.prismic.allHomepages.edges.slice(0, 1).pop();
    const projects = data.prismic.allProjects.edges;
    const meta = data.site.siteMetadata;
    if (!projects) return null;

    return (
        <Work projects={projects} meta={meta} homedat={homedat.node} />
    )
}

Work.propTypes = {
    homedat: PropTypes.array.isRequired,
    projects: PropTypes.array.isRequired,
};

export const query = graphql`
    {
        prismic {
            allHomepages {
                edges {
                    node {
                        work_title
                        work_copy
                        work_image
                    }
                }
            }
            allProjects {
                edges {
                    node {
                        title
                        subtitle
                        preview_description
                        thumbnail
                        hero
                        challenge_subtitle
                        challenge_copy
                        challenge_image
                        process_subtitle
                        process_copy
                        process_image
                        solution_subtitle
                        solution_copy
                        solution_image
                        results_subtitle
                        results_copy
                        results_image
                        meta_title
                        meta_description
                        og_title
                        og_description
                        og_image
                        _meta {
                            uid
                        }
                    }
                }
            }
        }
        site {
            siteMetadata {
                title
                description
                author
            }
        }
    }
`

